import { styled } from '@mui/system'
import { Box, Checkbox, Paper, TableCell, TableRow, Typography } from '@mui/material'
import Chip from '@mui/material/Chip'

export const StyledPaper = styled(Paper)(() => ({
  width: '100%',
  marginBottom: '8px',
}))

export const StyledBox = styled(Box)(() => ({
  padding: '8px',
}))

export const StyledChip = styled(Chip)(() => ({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontSize: '13px',
  lineHeight: '18px',
  letterSpacing: '0.15px',
  color: 'rgba(0, 0, 0, 0.87)',
  height: '24px',
}))

export const StyledBoxLabel = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export const StyledTypographyHeadLabel = styled(Typography)(() => ({
  fontSize: '14px',
  lineHeight: '24px',
  fontStyle: 'normal',
  fontWeight: '500',
}))

export const StyledTypographyHeadHyphen = styled(Typography)(() => ({
  width: '2px',
  height: '14px',
}))

export const StyledTableCell = styled(TableCell)(() => ({
  padding: '14px 10px',
}))
